export default __webpack_public_path__ + "static/cog-4de2e532018da4427c7673eaecc31ef0.svg";